import { UserExtensionConfig, UserExtensionFactory } from '../Extension';
import { SlackUserExtension } from './SlackUserExtension';

export class SlackUserExtensionFactory implements UserExtensionFactory<SlackUserExtension> {
  create(config: UserExtensionConfig): SlackUserExtension {
    return config as SlackUserExtension;
  }
}
